import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Landing from './pages/landing';
import ReportExample from './pages/report/Example';
import ReportPage from './pages/report/ReportPage';
import PaymentReturn from './pages/payment/PaymentReturn';
import AvisoLegal from './pages/legal/AvisoLegal';
import Privacidad from './pages/legal/Privacidad';
import Condiciones from './pages/legal/Condiciones';
import Unsubscribe from './pages/monitoring/Unsubscribe';

// The admin panel is private and large: loaded only when /admin is opened,
// so it adds nothing to what visitors download.
const AdminPanel = lazy(() => import('./pages/admin/AdminPanel'));

// Addresses of the previous product (URL audit dashboard, plans, payments).
// It no longer exists, but links to it may: send them to the home page
// instead of a 404.
const RETIRED_PATHS = [
  '/seo-audit-dashboard',
  '/live-audit-analysis/:auditId',
  '/seo-analysis-results/:auditId',
  '/audit-history-management',
  '/report-export-customization',
  '/payment-success',
  '/payment-cancelled'
];

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Landing />} />
          <Route path="/informe/ejemplo" element={<ReportExample />} />
          <Route path="/informe/:reportId" element={<ReportPage />} />
          <Route path="/pago/ok" element={<PaymentReturn />} />
          <Route path="/legal/aviso-legal" element={<AvisoLegal />} />
          <Route path="/legal/privacidad" element={<Privacidad />} />
          <Route path="/legal/condiciones" element={<Condiciones />} />
          <Route path="/seguimiento/baja" element={<Unsubscribe />} />
          <Route
            path="/admin"
            element={
              <Suspense fallback={<div className="min-h-screen bg-[#0a0a0b]" />}>
                <AdminPanel />
              </Suspense>
            }
          />
          <Route path="/admin/codigos" element={<Navigate to="/admin?tab=codigos" replace />} />
          {RETIRED_PATHS.map((path) => (
            <Route key={path} path={path} element={<Navigate to="/" replace />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
